import { jobAdjustmentApi } from './jobAdjustmentApi';

const skipJobAdjustment = async (jobId: string): Promise<void> => {
  await jobAdjustmentApi.skipJobAdjustment(jobId);
};

export const jobAdjustmentService = {
  skipJobAdjustment,
};
